export default __webpack_public_path__ + "static/media/pillow.61292b99.svg";